// © 2025 Camp Promethean, LLC. All Rights Reserved.
// Integrations Manager Component
// Allows users to manage third-party API integrations

import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AroyaIntegration } from "./AroyaIntegration";
import { GrowlinkIntegration } from "./GrowlinkIntegration";
import { useAuth } from "@/contexts/AuthContext";

export function IntegrationsManager() {
  const [activeTab, setActiveTab] = useState("aroya");
  const { profile } = useAuth();

  if (!profile) {
    return <div>Loading...</div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Integrations</h2>
        <p className="text-muted-foreground">
          Connect your Camp Promethean account with third-party services and platforms.
        </p>
      </div>

      <Tabs defaultValue="aroya" value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="aroya">Aura</TabsTrigger>
          <TabsTrigger value="growlink">Growlink</TabsTrigger>
          <TabsTrigger value="other" disabled>Other</TabsTrigger>
        </TabsList>
        
        <TabsContent value="aroya" className="space-y-4 mt-4">
          <AroyaIntegration profile={profile} />
        </TabsContent>
        
        <TabsContent value="growlink" className="space-y-4 mt-4">
          <GrowlinkIntegration profile={profile} />
        </TabsContent>
        
        <TabsContent value="other" className="space-y-4 mt-4">
          <Card>
            <CardHeader>
              <CardTitle>Additional Integrations</CardTitle>
              <CardDescription>
                Connect other services to enhance your Camp Promethean experience.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">Coming soon...</p>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
} 